import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from 'modules';
import queryString from 'query-string';
import ConsultingProgramAbout from 'components/programAbout/ConsultingProgramAbout';
import FinanceProgramAbout from 'components/programAbout/FinanceProgramAbout';
import TechProgramAbout from 'components/programAbout/TechProgramAbout';
import { EMentoringField } from 'enums/mentoring.enum';
import { Typography } from 'antd';
import styled from 'styled-components';
import 'animate.css/animate.min.css';

const { Text, Title } = Typography;
const ProgramAboutWrapper = styled.div``;
const ProgramAbout = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  let field = queryString.parse(useLocation().search)?.field?.toString();
  if (currentUser) {
    field = currentUser.primary_field;
  }

  return (
    <ProgramAboutWrapper>
      {field === EMentoringField.Consulting && <ConsultingProgramAbout />}
      {field === EMentoringField.Finance && <FinanceProgramAbout />}
      {field === EMentoringField.Tech && <TechProgramAbout />}
    </ProgramAboutWrapper>
  );
};

export default ProgramAbout;
